<template>
  <el-dialog
    title="库存编辑"
    :visible.sync="visible"
    width="400px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      size="small"
      label-width="80px"
      :model="model"
      :rules="rules"
      class="fix-width"
    >
      <el-form-item label="当前数量" class="long">
        {{ model.old_number }}
      </el-form-item>
      <el-form-item label="实际数量" prop="number">
        <el-input-number
          style="width: 177px"
          v-model="model.number"
          :min="0"
          :max="100000"
          :step-strictly="true"
        ></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="附件" class="long" prop="attachments">
        <AttachmentUpload
          v-model="model.attachments"
          @input="$refs.form.validate()"
        ></AttachmentUpload>
      </el-form-item> -->
      <el-form-item label="备注" class="long">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>
  
  <script>
import { productUpdateNumber } from '@/service/getData'
// import AttachmentUpload from './AttachmentUpload.vue'
export default {
  components: {
    // AttachmentUpload,
  },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        attachments: [
          {
            type: 'array',
            required: true,
            message: '请选择附件',
            trigger: 'change',
          },
        ],
        number: [
          { required: true, message: '请填写库存数量', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await productUpdateNumber(this.model)
          this.submiting = false
          if (res.code == 0) {
            this.$emit('callback', res.data)
            this.visible = false
          }
        }
      })
    },
  },
}
</script>